import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { PassengerState } from '../GroupOrder';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import AddPassengerWrapper from './AddPassengerWrapper';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../../../utils';
import ButtonBase from '@mui/material/ButtonBase';
import { Add } from '../../../../../Icons';

interface Props {
	passenger?: PassengerState;
	type?: 'default' | 'add' | 'error';
	onSelect?: (passenger: PassengerState, selected: boolean) => void;
	onAddPassenger?: (lastName: string, id: string, internalId?: string) => Promise<boolean>;
	isOpen?: boolean;
}

const Passenger: React.FC<Props> = props => {
	const theme = useTheme('Checkout').GroupOrder;

	const { t } = useTranslation('Checkout');
	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	const onChangeHandler = () => {
		props.onSelect(props.passenger, !props.passenger.selected);
	};

	const renderLabel = () => {
		return (
			<AddPassengerWrapper passenger={props.passenger} onAddPassenger={props.onAddPassenger}>
				<div>{props.passenger.passengerName}</div>

				{props.passenger.error && (
					<span className={theme.errorHint}>
						{t('Passenger not found. Please, check passenger last name and ticket number')}
					</span>
				)}
			</AddPassengerWrapper>
		);
	};

	if (props.type === 'add') {
		return (
			<div className={cn(theme.passenger, theme.addPassenger)}>
				<AddPassengerWrapper onAddPassenger={props.onAddPassenger} isOpen={props.isOpen}>
					{isMobile ? (
						<ButtonBase className={theme.addButton}>
							{t('Add passenger')} {Add}
						</ButtonBase>
					) : (
						<label className={theme.add}>
							<span>{t('Add your travel companion to the order? Add ticket')}</span>
							<span className={theme.addIcon}>{Add}</span>
						</label>
					)}
				</AddPassengerWrapper>
			</div>
		);
	}

	return (
		<FormControlLabel
			control={
				<Checkbox
					classes={{
						root: theme.checkbox,
						colorSecondary: theme.checkboxColor,
						checked: theme.checked
					}}
				/>
			}
			onChange={onChangeHandler}
			className={cn(theme.passenger, {
				[theme.error]: props.passenger.error
			})}
			checked={props.passenger.selected}
			label={renderLabel()}
			classes={{
				label: theme.passenger__label
			}}
		/>
	);
};

export default Passenger;
